module.exports = __webpack_public_path__ + "img/FORD.90978a74.webp";